import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from 'styles/tag_input.module.scss';
import classNames from 'lib/classNames';
import { Tag, Icon } from 'components';

const TagInput = ({ tags, close }) => {
	return (
		<div className={classNames('px-3 p-1 bg-gray-200 mt-6 rounded ')}>
			<div className={classNames('flex -mx-2 flex-wrap')}>
				{tags.map((tag) => (
					<div className={classNames('px-1 w-1/2 py-1')} key={tag.id}>
						<Tag {...tag} onClose={close} />
					</div>
				))}
			</div>
		</div>
	);
};

TagInput.propTypes = {
	tags: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
			image: PropTypes.string,
			title: PropTypes.string.isRequired,
		})
	),
	close: PropTypes.func.isRequired,
};

export default TagInput;
